export const getProfessors = (state) => state.facultyProfilePageGuidance;
